import axios from "../http"; // 导入axios实例
import qs from "qs"; // 根据需求是否导入qs模块

const getProduct ={
    getShopProduct(params) {
        return axios.post(`/mobile/product/lists`,qs.stringify(params));
    },
    getCateProduct(params) {
        return axios.post(`/mobile/product/cate_search`,qs.stringify(params));
    }
}
export default getProduct;


// WEBPACK FOOTER //
// ./src/assets/js/api/require/product.js